// app/adminSL/question/questions.js

(function () {
    "use strict";
    var controllerId = "asl_question";
    var urlAPI = "/api";
    angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$location", "$q", "common", "$routeParams", "datacontext", "sectionMenu", "_", asl_questionFn]);

    function asl_questionFn($rootScope, $scope, $location, $q, common, $routeParams, datacontext, sectionMenu, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.view = "list";       //Opzione list or detail
        vm.setView = setView;

        vm.objName = "question"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.test = {};
        vm.questionTest = {};
        vm.records = [];
        vm.deletedFiles = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["testuale", "data"];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };
        //Elenchi dettaglio
        vm.getListChoices = getListChoices;

        //Filtro
        vm.filter = {};
        vm.filter.testuale = " ";
        vm.fTestuale;

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.item = {};
        vm.get = getRecord;
        vm.doAction = doAction;
        vm.backToTest = backToTest;

        // ---- ACTIVATE -------
        activate();
        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.questionId != null) {
                        setView("detail");
                        vm.testId = ($routeParams.testId != null) ? $routeParams.testId : 0;
                        vm.item.area = ($routeParams.area != null) ? $routeParams.area : 0;
                        
                        if (vm.item.area == 1)
                            vm.sectionMenu = sectionMenu.setSection("TestCondivisi");
                        else if (vm.item.area == 2)
                            vm.sectionMenu = sectionMenu.setSection("TestAcquistati");
                        else
                            vm.sectionMenu = sectionMenu.setSection("Test");

                        getRecord($routeParams.questionId, vm.index, false);
                        if (vm.testId > 0) {
                            getTest(vm.testId);
                            getQuestionTest(vm.testId, $routeParams.questionId);
                        }
                        else
                            countByFilter();
                    }
                });
        }       

        //****************************************************
        /*CROP IMAGE */
        //****************************************************
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.cropper.cropWidthMax = 400;
        vm.cropper.cropHeightMax = 200;
        vm.bounds = {};
        vm.bounds.left = 1;
        vm.bounds.right = 200;
        vm.bounds.top = 100;
        vm.bounds.bottom = 1;

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.testuale = vm.fTestuale == null ? "" : vm.fTestuale;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.question_countByFilter(vm.filter.testuale).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.question_getAllByFilter(vm.pageSize, vm.page, vm.filter.testuale, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index, bClone) {
            return datacontext.question_get(id).then(function (data) {
                if (typeof (data) == "undefined" || data == "404")
                    return;

                vm.record = data;
                vm.record.image = vm.record.imgPath;
                vm.record.choices.forEach(function (ch) {
                    ch.image = ch.imgPath;
                });                
                
                setView("detail");
            });
        }

        function doAction(action) {            
                switch (action) {
                    case "goNext":
                        return _goNext();
                    case "goPrev":
                        return _goPrev();                
            }
        }

        function _goNext() {
            if (vm.index + 1 >= vm.countRecords) return;
            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                getAllByFilter();
                return; //TODO quando accodo il blocco successivo devo attendere il caricamento e andare al successivo
            }
            if (!vm.records) return;

            vm.index++;

            //Vado al successivo
            if (typeof (vm.test.Id) == "undefined" || vm.test.Id == 0)
                return getRecord(vm.records[vm.index].Id, vm.index, false);
            else
                return getRecord(vm.records[vm.index].questionId, vm.index, false);
        }

        function _goPrev() {
            if (vm.index <= 0) return;
            if (vm.index - 1 >= vm.records.length && vm.index - 1 < vm.countRecords) {
                getAll();
                return; //TODO quando accodo il blocco successivo devo attendere il caricamento e andare al precedente
            }
            if (!vm.records) return;

            vm.index--;
            if (typeof (vm.test.Id) == "undefined" || vm.test.Id == 0)
                return getRecord(vm.records[vm.index].Id, vm.index, false);
            else
                return getRecord(vm.records[vm.index].questionId, vm.index, false);
        }

        function titleEditBlur() {
            vm.titleEdit = false;
            if (vm.titleEdited == true)
                vm.item.editForm = true;
        }

        function titleEditFocus(bFocus) {
            if (vm.item.readonly)
                return;
            if (bFocus == true) {
                vm.titleEdit = true;
                //$("#title").focus();
            } else {
                if (!$("#title").is(":focus"))
                    vm.titleEdit = false;
            }
        }      

        function getListChoices(id) {
            if (!id) return;

            return datacontext.choice_getAllByQuestion(id, "").then(function (data) {
                return vm.record.choices = data;
            });
        }

        //Elenchi Parametri      
        function getTest(testId) {
            if (testId == 0)
                return false;

            return datacontext.test_get(testId).then(function (data) {
                //per attivare la navigazione delle domande del Test
                vm.records = _.sortBy(data.questions, function (o) { return o.sequence; });

                vm.countRecords = typeof (data.questions) != "undefined" ? data.questions.length : 0;

                //if (vm.record.Id == 0 || vm.index < 0) vm.index = vm.countRecords;
                if (typeof (vm.record.Id) == "undefined" || vm.record.Id == 0) {
                    //NUOVA DOMANDA
                    vm.index = vm.countRecords;//Necessario perch� il getTest risponde dopo il getRecord dove viene gestito il vm.index
                }
                return vm.test = data;
            });
        }

        function getQuestionTest(testId, questionId) {
            if (questionId == 0 || testId == 0)
                return false;

            return datacontext.questionTest_getAllByQuestion(testId, questionId, "").then(function (data) {
                //Per gestire correttamente la navigazione delle domande del test
                vm.index = data.sequence - 1;
                return vm.questionTest = data;
            });
        }

        function backToTest() {
            if(vm.item.area == 1)
                $location.url("/EDUP_testColleghi?testId=" + vm.testId);
            else if (vm.item.area == 2)
                $location.url("/EDUP_testAcquistati?testId=" + vm.testId);
            else
                $location.url("/asl_test?testId=" + vm.testId);
                
        }
    }
})();
